module.exports = __webpack_public_path__ + "img/25.ea31ac90.svg";